export default {
  inputFilledCountList: [{ label: "ダミー", number: 1, maxNumber: 3 }],
};
